import createListDataFetchManagementStoreSlice from '../../../modules/utilities/store/slices/listDataFetchManagement'

const sliceName = 'trackingGroupManagementExperience.list'

const TrackingGroupManagementTrackingGroupListSlice = createListDataFetchManagementStoreSlice(
  sliceName
)

export default TrackingGroupManagementTrackingGroupListSlice
